// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PPg9","importantInfo":"styles_importantInfo__26ipQ"};